<script>
  import AutotrainFinetuning from '../components/AutotrainFinetuning.svelte';
</script>

<div class="container">
  <h1 class="title">모델 파인튜닝 123</h1>
  <p class="notice">HuggingFace Autotrain을 활용한 파인튜닝 기능은 현재 구현 예정입니다.</p>
  <AutotrainFinetuning />
</div>

<style>
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem 1rem;
  }

  .title {
    text-align: center;
    margin-bottom: 1rem;
    font-size: 2rem;
    background: linear-gradient(90deg, #FF6382, #7C4DFF);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .notice {
    text-align: center;
    margin-bottom: 2rem;
    color: #FF6382;
  }
</style>